import React from "react";
import { useSelector } from "react-redux";
import {
  closeInfoPage,
  selectInfoPage,
  toggleInfoPage,
} from "slices/textSlice";
import EfsTippy from "components/HOCS/EfsTippy";
import Info from "graphics/icons/Info";
import { selectCurrentActiveEffice } from "slices/sharedSelectors";
import ShortenedTitle from "components/General-UI/ShortenedTitle";
import {
  isPrivateEffice,
  isRootEffice,
  isTextNode,
} from "helpers/efficeHelpers";
import { goToEffice } from "slices/efficeTreeSlice";
import ArrowMore from "graphics/icons/General/ArrowMore";
import XbuttonBusiness from "graphics/icons/XbuttonBusiness";
import { PrivateLockBlue } from "graphics/icons/BranchBar/PrivateLock";
import { APP_CODE_BRANCH } from "constants/constants";
import AppIcon from "components/Home/ui/AppIcon/AppIcon";

const TextHeader = ({ currentAppId }) => {
  const isCurrentlyBranch = currentAppId === APP_CODE_BRANCH;
  const currentActiveEffice = useSelector(selectCurrentActiveEffice);
  const infoPageActive = useSelector(selectInfoPage) && !isCurrentlyBranch;

  return (
    <div
      className={`Txt-header ${infoPageActive ? "tab-active" : ""} ${
        isCurrentlyBranch ? "pe-none" : ""
      }`}
      onClick={infoPageActive ? closeInfoPage : null}
    >
      <div className={`header-content`}>
        {isTextNode(currentActiveEffice) && (
          <button
            className="backer"
            onClick={() => goToEffice(currentActiveEffice.parent_id)}
          >
            <ArrowMore />
          </button>
        )}
        {currentActiveEffice &&
          !currentActiveEffice.pinned &&
          currentActiveEffice.parent_id !== null && (
            <span style={{ color: "grey" }}>Thread - </span>
          )}
        <EfsTippy
          content={`${infoPageActive ? "Close Details" : "Details"}`}
          placement="bottom"
          className="normal-Tippy"
          delay={[400, 0]}
        >
          <span
            className={`branch-title ${infoPageActive ? "active" : ""}`}
            onClick={toggleInfoPage}
          >
            <span className="text-header-icon">
              <AppIcon appId={currentActiveEffice?.app_id} isOpen={true} />
              {isPrivateEffice(currentActiveEffice) &&
                !isRootEffice(currentActiveEffice) && <PrivateLockBlue />}
            </span>
            <ShortenedTitle
              maxChars={100}
              title={currentActiveEffice?.content}
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div
              className={`info-tab ${infoPageActive ? "active-button" : ""}`}
            >
              <span className={`toggle-button`}>
                <Info />
              </span>

              {infoPageActive && (
                <span className="x-button">
                  <XbuttonBusiness />
                </span>
              )}
            </div>
          </span>
        </EfsTippy>
      </div>
    </div>
  );
};

export default TextHeader;
